<!--suppress AngularUndefinedBinding -->
<nav class="breadcrumb-one" aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><a href="javascript:void(0);">
      <svg class="feather feather-home" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
        <polyline points="9 22 9 12 15 12 15 22"></polyline>
      </svg>
    </a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/settings" translate>Settings</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate><a href="/private/subscription-update" translate>Subscription Info</a></li>
    <li class="breadcrumb-item active" aria-current="page" translate>Choose Package</li>
  </ol>
</nav>
<div [hidden]="loading" *ngIf="selectedSubscription" class="account-settings-container layout-top-spacing">
  <div class="account-content">
    <div class="scrollspy-example" data-spy="scroll" data-target="#account-settings-scroll" data-offset="-100">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 layout-spacing">
          <app-package-panel *ngIf="myBusiness" [message]="msg"
                             [myBusiness]="myBusiness"
                             [wallet]="myBusiness.walletAmount" [isPaying]="true"
                             [submitting]="submitting"
                             (paymentSubmitted)="paymentSubmitted($event)"
                             [lang]="lang"
                             [paylinkSubscription]="selectedSubscription"></app-package-panel>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="d-flex">
    <div class="mx-auto spinner-grow text-info align-self-center loader-lg"></div>
  </div>
</div>

<!-- Modal -->
<div class="modal fade" [id]="'proceedModal'" tabindex="-1" role="dialog" [attr.aria-labelledby]="'proceedModalLabel'" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [id]="'proceedModalLabel'">{{ 'Confirm Payment' | translate }}</h5>
        <button type="button" (click)="reloadPage()" class="close" data-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body">
        <p class="modal-text" translate>Your balance is not enough to complete the process! Do you want to pay the package now and deduct your balance later? Note: The current balance, if any, will be used, and the remaining balance will be calculated as a debit amount (negative) until the amount is satisfied</p>
        <p>{{ 'Current Balance' | translate }}: <span class="text-success" *ngIf="this.myBusiness">{{ this.myBusiness.walletAmount | number:'1.2-2' }} {{ 'SAR' | translate }}</span></p>
        <p *ngIf="this.data">{{ 'Subscription Amount' | translate }}: <span class="text-primary">{{ (this.data.amount) | number:'1.2-2' }} {{ 'SAR' | translate }}</span></p>
        <p *ngIf="this.data && this.myBusiness">{{ 'Your wallet balance will be' | translate }}: <span class="text-danger">{{ this.myBusiness.walletAmount - (this.data.amount) | number:'1.2-2' }} {{ 'SAR' | translate }}</span></p>
      </div>
      <div class="modal-footer">
        <button class="btn" (click)="reloadPage()" data-dismiss="modal" translate><i class="flaticon-cancel-12"></i>No</button>
        <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="paymentSubmittedAgain()" translate>Yes</button>
      </div>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" [id]="'minusPlanOkModal'" tabindex="-1" role="dialog" [attr.aria-labelledby]="'minusPlanOkModalLabel'" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" [id]="'minusPlanOkModalLabel'">{{ 'Successful Subscription' | translate }}</h5>
      </div>
      <div class="modal-body">
        <p class="modal-text" translate>Thank you, your subscription has been accepted and activated. It was included in your account as a debtor's amount (negative) until the amount is met</p>
      </div>
      <div class="modal-footer">
        <button type="button" data-dismiss="modal" class="btn btn-primary" (click)="continueAfterPayment()" translate>OK</button>
      </div>
    </div>
  </div>
</div>
